import React from 'react'

const Overview = ({MembershipOverview}) => {
    const {title='',description='',membershipData=[]}=MembershipOverview
  return (
    <div className="container">
        <div className='infographic-wrp'>
            <div className='hero-text'>
                <h1>{title}</h1>
                <p class="subheader-size">{description}</p>
            </div>
            <div className='membership-items'>
                {membershipData.length>0 && membershipData.map((item,index)=>{
                    return  <div className='membership-item-box'>
                                <img src={item.image} alt={item.title}/>
                                <h5>{item.title}</h5>
                            </div>
                })}
            </div>
            {/* <div className='hero-image'>

                <img src={image} alt="" />
            </div> */}
        </div>
   </div>
  )
}

export default Overview